import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVisionProApp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vision-pro-app, window"><path fillRule="evenodd" clipRule="evenodd" d="M3 4.75C3 4.33579 3.33579 4 3.75 4H22.25C22.6642 4 23 4.33579 23 4.75V17.1786C23 17.5928 22.6642 17.9286 22.25 17.9286H20V19.25C20 19.6642 19.6642 20 19.25 20H6.75C6.33579 20 6 19.6642 6 19.25V17.9286H3.75C3.33579 17.9286 3 17.5928 3 17.1786V4.75ZM7.5 18.5H18.5V17H7.5V18.5ZM0.75 8C1.16421 8 1.5 8.33579 1.5 8.75V13.25C1.5 13.6642 1.16421 14 0.75 14C0.335786 14 0 13.6642 0 13.25V8.75C0 8.33579 0.335786 8 0.75 8Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVisionProApp;
